import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const thumbnails: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20bedroom%20with%20soft%20moonlight%20through%20window%2C%20headphones%20resting%20on%20pillow%2C%20cream%20colored%20bedding%2C%20aromatherapy%20diffuser%20with%20gentle%20mist%2C%20wooden%20nightstand%20with%20sleeping%20mask%2C%20minimalist%20peaceful%20composition%2C%20soft%20amber%20warm%20tones%2C%20editorial%20interior%20photography&width=800&height=500&seq=article-img-01&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=Old%20wooden%20library%20interior%20with%20tall%20bookshelves%2C%20warm%20amber%20lighting%20from%20table%20lamp%2C%20leather%20armchair%2C%20stack%20of%20old%20books%20on%20wooden%20table%2C%20dust%20particles%20in%20light%20beam%2C%20quiet%20atmosphere%2C%20cream%20and%20brown%20tones%2C%20editorial%20photography&width=800&height=500&seq=article-img-02&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Crispy%20golden%20fried%20chicken%20on%20ceramic%20plate%2C%20glass%20of%20sparkling%20water%20with%20ice%2C%20warm%20kitchen%20lighting%2C%20wooden%20table%20surface%2C%20steam%20rising%2C%20minimalist%20food%20photography%2C%20cream%20and%20golden%20tones%2C%20soft%20shadows%2C%20editorial%20style&width=800&height=500&seq=article-img-03&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=Professional%20studio%20microphone%20with%20shock%20mount%20on%20wooden%20desk%2C%20soft%20warm%20lighting%2C%20acoustic%20foam%20panels%20in%20background%2C%20headphones%20nearby%2C%20cozy%20dark%20atmosphere%20with%20amber%20glow%2C%20professional%20audio%20recording%20setup%2C%20minimalist%20composition&width=800&height=500&seq=article-img-05&orientation=landscape',
  7: 'https://readdy.ai/api/search-image?query=Spa%20massage%20room%20with%20soft%20candles%20and%20essential%20oils%2C%20warm%20wooden%20interior%2C%20white%20towels%20neatly%20folded%2C%20diffused%20warm%20lighting%2C%20peaceful%20meditation%20space%2C%20bamboo%20and%20stone%20elements%2C%20cream%20and%20beige%20tones%2C%20editorial%20spa%20photography&width=800&height=500&seq=article-img-07&orientation=landscape',
  11: 'https://readdy.ai/api/search-image?query=Soft%20feminine%20bedroom%20at%20night%2C%20fairy%20lights%20on%20wall%2C%20fluffy%20pillows%20and%20blankets%2C%20warm%20cozy%20atmosphere%2C%20book%20on%20nightstand%2C%20moonlight%20through%20sheer%20curtains%2C%20gentle%20pink%20and%20cream%20tones%2C%20dreamy%20soft%20focus%2C%20editorial%20interior&width=800&height=500&seq=article-img-11&orientation=landscape',
  14: 'https://readdy.ai/api/search-image?query=Cozy%20reading%20room%20with%20burning%20fireplace%2C%20rain%20on%20window%2C%20leather%20armchair%2C%20bookshelf%2C%20warm%20amber%20fire%20light%2C%20wooden%20floor%2C%20cup%20of%20tea%2C%20soft%20blanket%2C%20intimate%20peaceful%20atmosphere%2C%20cream%20and%20brown%20tones%2C%20editorial%20interior%20photography&width=800&height=500&seq=article-img-14&orientation=landscape',
};

const FeaturedArticles: FC = () => {
  const featured = articles.filter((a) => a.isFeatured).slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-2">
              精选内容推荐
            </h2>
            <p className="text-sm text-foreground-600">编辑团队精心挑选的高品质ASMR内容</p>
          </div>
          <Link
            to="/category/shuimian-fangsong"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
          >
            查看全部 <div className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></div>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={thumbnails[article.id] || thumbnails[1]}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="px-2.5 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors duration-200 line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200/60">
                  <span className="text-xs text-foreground-500">{article.author} · {article.date}</span>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <div className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-eye-line"></i></div>
                      {article.viewCount > 10000 ? `${(article.viewCount / 10000).toFixed(1)}万` : article.viewCount}
                    </span>
                    <span className="flex items-center gap-1">
                      <div className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-heart-line"></i></div>
                      {article.likeCount}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/shuimian-fangsong"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap"
          >
            查看全部 <div className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedArticles;